import { MakeRequired } from '@/shared/types';
import { useStore } from '@/store';
import { defineComponent, reactive, toRefs } from '@vue/composition-api';
import Sidebar from './sidebar/sidebar.component.vue';

type ChildMenu = Omit<MakeRequired<Menu, 'link'>, 'children' | 'isActive'> & {
  isFocus: boolean;
};

type Menu = {
  text: string;
  icon: string;
  isActive: boolean;
  isAllow?: boolean;
  link?: string;
  children?: ChildMenu[];
};

// リアクティブな変数の型定義
export type ReactiveData = {
  isOpen: boolean;
  mainTitle: string;
  list: boolean;
  isSizeOver: boolean;
};

/**
 * 共通画面コンポーネント
 *
 * ヘッダ/サイドメニュー/各機能(router-outlet)の基盤となる
 */
export default defineComponent({
  components: { Sidebar },
  setup() {
    const store = useStore();
    const state = reactive<ReactiveData>({
      isOpen: true,
      mainTitle: '',
      list: false,
      isSizeOver: false, // ログインユーザー名が超過したか
    });

    const user = store.getters.user;
    /**
     * メインヘッダー部に表示するログインユーザー名取得
     */
    const getLoginUserName = () => {
      // ユーザー名を設定（後にstoreから取得するようにする）
      const loginUserName = user?.name || '';

      // ログインユーザー名が10文字より多い場合、11文字以降を表示しない
      if (loginUserName.length > 10) {
        // ログインユーザー名が超過したかのフラグをtrueにする
        state.isSizeOver = true;

        // 名前の10文字目までを取得し、11文字目を三点リーダーにする
        return loginUserName.substring(0, 10).concat('...');
      } else {
        return loginUserName;
      }
    };

    /**
     * ツールチップで表示するログインユーザーフルネーム取得
     */
    const getLoginUserFullName = () => {
      return user?.name || '';
    };

    /**
     * タイトルアイコンの取得
     *
     * @returns string タイトルアイコン
     */
    const getTitleIcon = () => {
      return store.state.title.icon;
    };

    /**
     * メインタイトルの取得
     *
     * @returns string メインタイトル
     */
    const getMainTitle = () => {
      return store.state.title.main;
    };

    const onOpen = () => {
      state.isOpen = true;
    };

    return {
      ...toRefs(state),
      getTitleIcon,
      getMainTitle,
      getLoginUserName,
      getLoginUserFullName,
      onOpen,
    };
  },
});
